import React from "react";
import { BirthDayDetails } from "../../../models/BirthDaysModels/BirthDayDetails";
import { Grid } from "@material-ui/core";
import InputText from "../../../../features/InputText";
import CheckboxCustom from "../../../../features/CheckboxCustom";
import TextAreaCustom from "../../../../features/TextAreaCustom";
import { useTranslation } from "react-i18next";

interface IProps {
  birthDayDetails: BirthDayDetails;
  onSetBirthDayDetails: (value: BirthDayDetails) => void;
  onNext: () => void;
}

const ThirdStep: React.FC<IProps> = ({ birthDayDetails, onSetBirthDayDetails, onNext }: IProps) => {
  const { t } = useTranslation();
  const validateForm = (): boolean => {
    return (
      Boolean(birthDayDetails.customerName) &&
      Boolean(birthDayDetails.customerLastName) &&
      Boolean(birthDayDetails.email) &&
      Boolean(birthDayDetails.phone)
    );
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <b>{t("osoba_rezerwujaca")}</b>
      </Grid>

      <Grid item xs={2}>
        <InputText
          value={birthDayDetails.customerName}
          label={t("imie")}
          name={"fname"}
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, customerName: value })}
        />
      </Grid>
      <Grid item xs={2}>
        <InputText
          value={birthDayDetails.customerLastName}
          label={t("nazwisko")}
          name={"flastname"}
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, customerLastName: value })}
        />
      </Grid>
      <Grid item xs={2}>
        <InputText
          value={birthDayDetails.email}
          label={"Email"}
          name={"femail"}
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, email: value })}
        />
      </Grid>
      <Grid item xs={2}>
        <InputText
          value={birthDayDetails.phone}
          label={t("telefon")}
          name={"fphone"}
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, phone: value })}
        />
      </Grid>
      <Grid item xs={8}>
        <CheckboxCustom
          label={t("chce_fakture")}
          value={birthDayDetails.isInvoice}
          setValue={(value: boolean) => onSetBirthDayDetails({ ...birthDayDetails, isInvoice: value })}
        />
      </Grid>
      <Grid item xs={12}>
        <TextAreaCustom
          label={t("dodatkowe_informacje_nt_rezerwacji")}
          value={birthDayDetails.additionalInfo}
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, additionalInfo: value })}
          name={"fadditionalInfo"}
        />
        <span>{t("w_tym_oknie_wpisz_przedzial_wiekowy_swojej_grupy")}</span>
      </Grid>

      <Grid item xs={4} className={"button-next"} style={{ marginTop: 40 }}>
        {Boolean(birthDayDetails.customerName) &&
        Boolean(birthDayDetails.customerLastName) &&
        Boolean(birthDayDetails.email) &&
        Boolean(birthDayDetails.phone) ? (
          <button
            className={"button medium padding-medium button-fill-main"}
            onClick={() => onNext()}
            disabled={!validateForm()}
          >
            {t("kontynuuj")}
          </button>
        ) : (
          <button className={"button medium padding-medium button-fill-gray"} disabled={!validateForm()}>
            {t("kontynuuj")}
          </button>
        )}
      </Grid>
    </Grid>
  );
};

export default ThirdStep;
